var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }],
    ref: "page",
    staticClass: "page"
  }, [_c("el-tabs", {
    model: {
      value: _vm.activeName,
      callback: function callback($$v) {
        _vm.activeName = $$v;
      },
      expression: "activeName"
    }
  }, [_c("el-tab-pane", {
    attrs: {
      label: "图表",
      name: "echart"
    }
  }, [_c("div", {
    ref: "wrap",
    staticClass: "wrap"
  }, [_c("el-card", {
    staticClass: "el-card"
  }, [_c("div", {
    staticClass: "card-title",
    attrs: {
      slot: "header"
    },
    slot: "header"
  }, [_c("el-date-picker", {
    staticClass: "year",
    attrs: {
      size: "small",
      type: "year",
      clearable: false,
      placeholder: "选择年"
    },
    on: {
      change: _vm.update
    },
    model: {
      value: _vm.year,
      callback: function callback($$v) {
        _vm.year = $$v;
      },
      expression: "year"
    }
  })], 1), _c("div", {
    staticClass: "card-content"
  }, [_c("div", {
    staticClass: "chart-item"
  }, [_c("div", {
    staticClass: "chart-item-title"
  }, [_vm._v("银行函证数量统计(" + _vm._s(_vm.bankDataSum) + ")")]), _c("div", {
    ref: "bank",
    staticClass: "chart",
    attrs: {
      id: "bank"
    }
  })]), _c("div", {
    staticClass: "chart-item bar"
  }, [_c("div", {
    staticClass: "chart-item-title"
  }, [_vm._v("银行回函异常统计")]), _c("div", {
    ref: "bankBack",
    staticClass: "chart",
    attrs: {
      id: "bankBack"
    }
  })]), _c("div", {
    staticClass: "chart-item"
  }, [_c("div", {
    staticClass: "chart-item-title"
  }, [_vm._v("银行回函跟踪统计")]), _c("div", {
    ref: "bankTrack",
    staticClass: "chart",
    attrs: {
      id: "bankTrack"
    }
  })])])]), _c("el-card", {
    staticClass: "el-card"
  }, [_c("div", {
    staticClass: "card-content"
  }, [_c("div", {
    staticClass: "chart-item"
  }, [_c("div", {
    staticClass: "chart-item-title"
  }, [_vm._v("往来函证数量统计(" + _vm._s(_vm.companyDataSum) + ")")]), _c("div", {
    ref: "company",
    staticClass: "chart",
    attrs: {
      id: "company"
    }
  })]), _c("div", {
    staticClass: "chart-item bar"
  }, [_c("div", {
    staticClass: "chart-item-title"
  }, [_vm._v("往来回函异常统计")]), _c("div", {
    ref: "companyBack",
    staticClass: "chart",
    attrs: {
      id: "companyBack"
    }
  })]), _c("div", {
    staticClass: "chart-item"
  }, [_c("div", {
    staticClass: "chart-item-title"
  }, [_vm._v("往来回函跟踪统计")]), _c("div", {
    ref: "companyTrack",
    staticClass: "chart",
    attrs: {
      id: "companyTrack"
    }
  })])])]), _c("el-card", {
    staticClass: "el-card"
  }, [_c("div", {
    staticClass: "card-content"
  }, [_c("div", {
    staticClass: "chart-item"
  }, [_c("div", {
    staticClass: "chart-item-title"
  }, [_vm._v("其他函证数量统计(" + _vm._s(_vm.otherDataSum) + ")")]), _c("div", {
    ref: "other",
    staticClass: "chart",
    attrs: {
      id: "other"
    }
  })]), _c("div", {
    staticClass: "chart-item bar"
  }, [_c("div", {
    staticClass: "chart-item-title"
  }, [_vm._v("其他回函异常统计")]), _c("div", {
    ref: "otherBack",
    staticClass: "chart",
    attrs: {
      id: "otherBack"
    }
  })]), _c("div", {
    staticClass: "chart-item"
  }, [_c("div", {
    staticClass: "chart-item-title"
  }, [_vm._v("其他回函跟踪统计")]), _c("div", {
    ref: "otherTrack",
    staticClass: "chart",
    attrs: {
      id: "otherTrack"
    }
  })])])])], 1)]), _c("el-tab-pane", {
    attrs: {
      label: "表格",
      name: "table"
    }
  }, [_c("el-collapse", {
    model: {
      value: _vm.collapse,
      callback: function callback($$v) {
        _vm.collapse = $$v;
      },
      expression: "collapse"
    }
  }, [_c("el-collapse-item", {
    attrs: {
      title: "作业函证量统计",
      name: "1"
    }
  }, [_c("div", {
    staticClass: "filter-wrap"
  }, [_c("div", {
    staticClass: "item"
  }, [_c("el-tag", {
    attrs: {
      size: "small",
      effect: "dark"
    }
  }, [_vm._v(" 回函比例 ")])], 1), _c("div", {
    staticClass: "sub-wrap"
  }, [_c("div", {
    staticClass: "sub-item"
  }, [_c("div", {
    staticClass: "filter-component-item"
  }, [_c("div", {
    staticClass: "label"
  }, [_c("el-tag", {
    attrs: {
      size: "small",
      type: "success"
    }
  }, [_vm._v(" 银行 ")])], 1), _c("el-select", {
    staticClass: "input",
    attrs: {
      size: "small",
      placeholder: "请选择"
    },
    model: {
      value: _vm.filterForm.bank.back.type,
      callback: function callback($$v) {
        _vm.$set(_vm.filterForm.bank.back, "type", $$v);
      },
      expression: "filterForm.bank.back.type"
    }
  }, _vm._l(_vm.filterTypeOptions, function (item) {
    return _c("el-option", {
      key: item.value,
      attrs: {
        label: item.label,
        value: item.value
      }
    });
  }), 1), _c("el-input-number", {
    staticClass: "input",
    attrs: {
      size: "small",
      precision: 2,
      min: 0,
      max: 100,
      label: "回函比例"
    },
    model: {
      value: _vm.filterForm.bank.back.value,
      callback: function callback($$v) {
        _vm.$set(_vm.filterForm.bank.back, "value", $$v);
      },
      expression: "filterForm.bank.back.value"
    }
  }), _c("div", {
    staticClass: "unit"
  }, [_vm._v("%")])], 1), _c("div", {
    staticClass: "filter-component-item"
  }, [_c("div", {
    staticClass: "label"
  }, [_c("el-tag", {
    attrs: {
      size: "small",
      type: ""
    }
  }, [_vm._v(" 往来 ")])], 1), _c("el-select", {
    staticClass: "input",
    attrs: {
      size: "small",
      placeholder: "请选择"
    },
    model: {
      value: _vm.filterForm.w.back.type,
      callback: function callback($$v) {
        _vm.$set(_vm.filterForm.w.back, "type", $$v);
      },
      expression: "filterForm.w.back.type"
    }
  }, _vm._l(_vm.filterTypeOptions, function (item) {
    return _c("el-option", {
      key: item.value,
      attrs: {
        label: item.label,
        value: item.value
      }
    });
  }), 1), _c("el-input-number", {
    staticClass: "input",
    attrs: {
      size: "small",
      precision: 2,
      min: 0,
      max: 100,
      label: "回函比例"
    },
    model: {
      value: _vm.filterForm.w.back.value,
      callback: function callback($$v) {
        _vm.$set(_vm.filterForm.w.back, "value", $$v);
      },
      expression: "filterForm.w.back.value"
    }
  }), _c("div", {
    staticClass: "unit"
  }, [_vm._v("%")])], 1), _c("div", {
    staticClass: "filter-component-wrap"
  }, [_c("div", {
    staticClass: "filter-component-item"
  }, [_c("div", {
    staticClass: "label"
  }, [_c("el-tag", {
    attrs: {
      size: "small",
      type: "danger"
    }
  }, [_vm._v(" 其他 ")])], 1), _c("el-select", {
    staticClass: "input",
    attrs: {
      size: "small",
      placeholder: "请选择"
    },
    model: {
      value: _vm.filterForm.q.back.type,
      callback: function callback($$v) {
        _vm.$set(_vm.filterForm.q.back, "type", $$v);
      },
      expression: "filterForm.q.back.type"
    }
  }, _vm._l(_vm.filterTypeOptions, function (item) {
    return _c("el-option", {
      key: item.value,
      attrs: {
        label: item.label,
        value: item.value
      }
    });
  }), 1), _c("el-input-number", {
    staticClass: "input",
    attrs: {
      size: "small",
      precision: 2,
      min: 0,
      max: 100,
      label: "回函比例"
    },
    model: {
      value: _vm.filterForm.q.back.value,
      callback: function callback($$v) {
        _vm.$set(_vm.filterForm.q.back, "value", $$v);
      },
      expression: "filterForm.q.back.value"
    }
  }), _c("div", {
    staticClass: "unit"
  }, [_vm._v("%")])], 1)])])])])]), _c("el-collapse-item", {
    attrs: {
      title: "回函异常函件统计",
      name: "2"
    }
  }, [_c("div", {
    staticClass: "filter-wrap"
  }, [_c("div", {
    staticClass: "item"
  }, [_c("div", {
    staticClass: "name"
  }, [_c("el-tag", {
    attrs: {
      size: "small",
      effect: "dark"
    }
  }, [_vm._v(" 银行 ")])], 1), _c("div", {
    staticClass: "sub-wrap"
  }, [_c("div", {
    staticClass: "sub-item"
  }, [_c("div", {
    staticClass: "filter-component-item"
  }, [_c("div", {
    staticClass: "label"
  }, [_c("el-tag", {
    attrs: {
      size: "small",
      type: "success"
    }
  }, [_vm._v(" 结论不符 ")])], 1), _c("el-select", {
    staticClass: "input",
    attrs: {
      size: "small",
      placeholder: "请选择"
    },
    model: {
      value: _vm.filterForm.bank.jielun.type,
      callback: function callback($$v) {
        _vm.$set(_vm.filterForm.bank.jielun, "type", $$v);
      },
      expression: "filterForm.bank.jielun.type"
    }
  }, _vm._l(_vm.filterTypeOptions, function (item) {
    return _c("el-option", {
      key: item.value,
      attrs: {
        label: item.label,
        value: item.value
      }
    });
  }), 1), _c("el-input-number", {
    staticClass: "input",
    attrs: {
      size: "small",
      precision: 2,
      min: 0,
      max: 100,
      label: "结论不符比例"
    },
    model: {
      value: _vm.filterForm.bank.jielun.value,
      callback: function callback($$v) {
        _vm.$set(_vm.filterForm.bank.jielun, "value", $$v);
      },
      expression: "filterForm.bank.jielun.value"
    }
  }), _c("div", {
    staticClass: "unit"
  }, [_vm._v("%")])], 1), _c("div", {
    staticClass: "filter-component-item"
  }, [_c("div", {
    staticClass: "label"
  }, [_c("el-tag", {
    attrs: {
      size: "small"
    }
  }, [_vm._v(" 函证异常 ")])], 1), _c("el-select", {
    staticClass: "input",
    attrs: {
      size: "small",
      placeholder: "请选择"
    },
    model: {
      value: _vm.filterForm.bank.yichang.type,
      callback: function callback($$v) {
        _vm.$set(_vm.filterForm.bank.yichang, "type", $$v);
      },
      expression: "filterForm.bank.yichang.type"
    }
  }, _vm._l(_vm.filterTypeOptions, function (item) {
    return _c("el-option", {
      key: item.value,
      attrs: {
        label: item.label,
        value: item.value
      }
    });
  }), 1), _c("el-input-number", {
    staticClass: "input",
    attrs: {
      size: "small",
      precision: 2,
      min: 0,
      max: 100,
      label: "函证异常比例"
    },
    model: {
      value: _vm.filterForm.bank.yichang.value,
      callback: function callback($$v) {
        _vm.$set(_vm.filterForm.bank.yichang, "value", $$v);
      },
      expression: "filterForm.bank.yichang.value"
    }
  }), _c("div", {
    staticClass: "unit"
  }, [_vm._v("%")])], 1), _c("div", {
    staticClass: "filter-component-item"
  }, [_c("div", {
    staticClass: "label"
  }, [_c("el-tag", {
    attrs: {
      size: "small",
      effect: "danger"
    }
  }, [_vm._v(" 地址异常 ")])], 1), _c("el-select", {
    staticClass: "input",
    attrs: {
      size: "small",
      placeholder: "请选择"
    },
    model: {
      value: _vm.filterForm.bank.dizhi.type,
      callback: function callback($$v) {
        _vm.$set(_vm.filterForm.bank.dizhi, "type", $$v);
      },
      expression: "filterForm.bank.dizhi.type"
    }
  }, _vm._l(_vm.filterTypeOptions, function (item) {
    return _c("el-option", {
      key: item.value,
      attrs: {
        label: item.label,
        value: item.value
      }
    });
  }), 1), _c("el-input-number", {
    staticClass: "input",
    attrs: {
      size: "small",
      precision: 2,
      min: 0,
      max: 100,
      label: "地址异常比例"
    },
    model: {
      value: _vm.filterForm.bank.dizhi.value,
      callback: function callback($$v) {
        _vm.$set(_vm.filterForm.bank.dizhi, "value", $$v);
      },
      expression: "filterForm.bank.dizhi.value"
    }
  }), _c("div", {
    staticClass: "unit"
  }, [_vm._v("%")])], 1)])])]), _c("div", {
    staticClass: "item"
  }, [_c("div", {
    staticClass: "name"
  }, [_c("el-tag", {
    attrs: {
      size: "small",
      type: "danger",
      effect: "dark"
    }
  }, [_vm._v(" 往来 ")])], 1), _c("div", {
    staticClass: "sub-wrap"
  }, [_c("div", {
    staticClass: "sub-item"
  }, [_c("div", {
    staticClass: "filter-component-item"
  }, [_c("div", {
    staticClass: "label"
  }, [_c("el-tag", {
    attrs: {
      size: "small",
      type: "success"
    }
  }, [_vm._v(" 结论不符 ")])], 1), _c("el-select", {
    staticClass: "input",
    attrs: {
      size: "small",
      placeholder: "请选择"
    },
    model: {
      value: _vm.filterForm.w.jielun.type,
      callback: function callback($$v) {
        _vm.$set(_vm.filterForm.w.jielun, "type", $$v);
      },
      expression: "filterForm.w.jielun.type"
    }
  }, _vm._l(_vm.filterTypeOptions, function (item) {
    return _c("el-option", {
      key: item.value,
      attrs: {
        label: item.label,
        value: item.value
      }
    });
  }), 1), _c("el-input-number", {
    staticClass: "input",
    attrs: {
      size: "small",
      precision: 2,
      min: 0,
      max: 100,
      label: "结论不符比例"
    },
    model: {
      value: _vm.filterForm.w.jielun.value,
      callback: function callback($$v) {
        _vm.$set(_vm.filterForm.w.jielun, "value", $$v);
      },
      expression: "filterForm.w.jielun.value"
    }
  }), _c("div", {
    staticClass: "unit"
  }, [_vm._v("%")])], 1), _c("div", {
    staticClass: "filter-component-item"
  }, [_c("div", {
    staticClass: "label"
  }, [_c("el-tag", {
    attrs: {
      size: "small"
    }
  }, [_vm._v(" 函证异常 ")])], 1), _c("el-select", {
    staticClass: "input",
    attrs: {
      size: "small",
      placeholder: "请选择"
    },
    model: {
      value: _vm.filterForm.w.yichang.type,
      callback: function callback($$v) {
        _vm.$set(_vm.filterForm.w.yichang, "type", $$v);
      },
      expression: "filterForm.w.yichang.type"
    }
  }, _vm._l(_vm.filterTypeOptions, function (item) {
    return _c("el-option", {
      key: item.value,
      attrs: {
        label: item.label,
        value: item.value
      }
    });
  }), 1), _c("el-input-number", {
    staticClass: "input",
    attrs: {
      size: "small",
      precision: 2,
      min: 0,
      max: 100,
      label: "函证异常比例"
    },
    model: {
      value: _vm.filterForm.w.yichang.value,
      callback: function callback($$v) {
        _vm.$set(_vm.filterForm.w.yichang, "value", $$v);
      },
      expression: "filterForm.w.yichang.value"
    }
  }), _c("div", {
    staticClass: "unit"
  }, [_vm._v("%")])], 1), _c("div", {
    staticClass: "filter-component-item"
  }, [_c("div", {
    staticClass: "label"
  }, [_c("el-tag", {
    attrs: {
      size: "small",
      type: "danger"
    }
  }, [_vm._v(" 地址异常 ")])], 1), _c("el-select", {
    staticClass: "input",
    attrs: {
      size: "small",
      placeholder: "请选择"
    },
    model: {
      value: _vm.filterForm.w.dizhi.type,
      callback: function callback($$v) {
        _vm.$set(_vm.filterForm.w.dizhi, "type", $$v);
      },
      expression: "filterForm.w.dizhi.type"
    }
  }, _vm._l(_vm.filterTypeOptions, function (item) {
    return _c("el-option", {
      key: item.value,
      attrs: {
        label: item.label,
        value: item.value
      }
    });
  }), 1), _c("el-input-number", {
    staticClass: "input",
    attrs: {
      size: "small",
      precision: 2,
      min: 0,
      max: 100,
      label: "地址异常比例"
    },
    model: {
      value: _vm.filterForm.w.dizhi.value,
      callback: function callback($$v) {
        _vm.$set(_vm.filterForm.w.dizhi, "value", $$v);
      },
      expression: "filterForm.w.dizhi.value"
    }
  }), _c("div", {
    staticClass: "unit"
  }, [_vm._v("%")])], 1)])])]), _c("div", {
    staticClass: "item"
  }, [_c("div", {
    staticClass: "name"
  }, [_c("el-tag", {
    attrs: {
      size: "small",
      type: "info",
      effect: "dark"
    }
  }, [_vm._v(" 其他 ")])], 1), _c("div", {
    staticClass: "sub-wrap"
  }, [_c("div", {
    staticClass: "sub-item"
  }, [_c("div", {
    staticClass: "filter-component-item"
  }, [_c("div", {
    staticClass: "label"
  }, [_c("el-tag", {
    attrs: {
      size: "small",
      type: "success"
    }
  }, [_vm._v(" 结论不符 ")])], 1), _c("el-select", {
    staticClass: "input",
    attrs: {
      size: "small",
      placeholder: "请选择"
    },
    model: {
      value: _vm.filterForm.q.jielun.type,
      callback: function callback($$v) {
        _vm.$set(_vm.filterForm.q.jielun, "type", $$v);
      },
      expression: "filterForm.q.jielun.type"
    }
  }, _vm._l(_vm.filterTypeOptions, function (item) {
    return _c("el-option", {
      key: item.value,
      attrs: {
        label: item.label,
        value: item.value
      }
    });
  }), 1), _c("el-input-number", {
    staticClass: "input",
    attrs: {
      size: "small",
      precision: 2,
      min: 0,
      max: 100,
      label: "结论不符比例"
    },
    model: {
      value: _vm.filterForm.q.jielun.value,
      callback: function callback($$v) {
        _vm.$set(_vm.filterForm.q.jielun, "value", $$v);
      },
      expression: "filterForm.q.jielun.value"
    }
  }), _c("div", {
    staticClass: "unit"
  }, [_vm._v("%")])], 1), _c("div", {
    staticClass: "filter-component-item"
  }, [_c("div", {
    staticClass: "label"
  }, [_c("el-tag", {
    attrs: {
      size: "small"
    }
  }, [_vm._v(" 函证异常 ")])], 1), _c("el-select", {
    staticClass: "input",
    attrs: {
      size: "small",
      placeholder: "请选择"
    },
    model: {
      value: _vm.filterForm.q.yichang.type,
      callback: function callback($$v) {
        _vm.$set(_vm.filterForm.q.yichang, "type", $$v);
      },
      expression: "filterForm.q.yichang.type"
    }
  }, _vm._l(_vm.filterTypeOptions, function (item) {
    return _c("el-option", {
      key: item.value,
      attrs: {
        label: item.label,
        value: item.value
      }
    });
  }), 1), _c("el-input-number", {
    staticClass: "input",
    attrs: {
      size: "small",
      precision: 2,
      min: 0,
      max: 100,
      label: "函证异常比例"
    },
    model: {
      value: _vm.filterForm.q.yichang.value,
      callback: function callback($$v) {
        _vm.$set(_vm.filterForm.q.yichang, "value", $$v);
      },
      expression: "filterForm.q.yichang.value"
    }
  }), _c("div", {
    staticClass: "unit"
  }, [_vm._v("%")])], 1), _c("div", {
    staticClass: "filter-component-item"
  }, [_c("div", {
    staticClass: "label"
  }, [_c("el-tag", {
    attrs: {
      size: "small",
      type: "danger"
    }
  }, [_vm._v(" 地址异常 ")])], 1), _c("el-select", {
    staticClass: "input",
    attrs: {
      size: "small",
      placeholder: "请选择"
    },
    model: {
      value: _vm.filterForm.q.dizhi.type,
      callback: function callback($$v) {
        _vm.$set(_vm.filterForm.q.dizhi, "type", $$v);
      },
      expression: "filterForm.q.dizhi.type"
    }
  }, _vm._l(_vm.filterTypeOptions, function (item) {
    return _c("el-option", {
      key: item.value,
      attrs: {
        label: item.label,
        value: item.value
      }
    });
  }), 1), _c("el-input-number", {
    staticClass: "input",
    attrs: {
      size: "small",
      precision: 2,
      min: 0,
      max: 100,
      label: "地址异常比例"
    },
    model: {
      value: _vm.filterForm.q.dizhi.value,
      callback: function callback($$v) {
        _vm.$set(_vm.filterForm.q.dizhi, "value", $$v);
      },
      expression: "filterForm.q.dizhi.value"
    }
  }), _c("div", {
    staticClass: "unit"
  }, [_vm._v("%")])], 1)])])])])]), _c("el-collapse-item", {
    attrs: {
      title: "项目组跟着回函统计",
      name: "3"
    }
  }, [_c("div", {
    staticClass: "filter-wrap"
  }, [_c("div", {
    staticClass: "item"
  }, [_c("div", {
    staticClass: "name"
  }, [_c("el-tag", {
    attrs: {
      size: "small",
      effect: "dark"
    }
  }, [_vm._v(" 银行 ")])], 1), _c("div", {
    staticClass: "sub-wrap"
  }, [_c("div", {
    staticClass: "sub-item"
  }, [_c("div", {
    staticClass: "filter-component-item"
  }, [_c("div", {
    staticClass: "label"
  }, [_c("el-tag", {
    attrs: {
      size: "small",
      type: "success"
    }
  }, [_vm._v(" 回函未跟 ")])], 1), _c("el-select", {
    staticClass: "input",
    attrs: {
      size: "small",
      placeholder: "请选择"
    },
    model: {
      value: _vm.filterForm.bank.weigen.type,
      callback: function callback($$v) {
        _vm.$set(_vm.filterForm.bank.weigen, "type", $$v);
      },
      expression: "filterForm.bank.weigen.type"
    }
  }, _vm._l(_vm.filterTypeOptions, function (item) {
    return _c("el-option", {
      key: item.value,
      attrs: {
        label: item.label,
        value: item.value
      }
    });
  }), 1), _c("el-input-number", {
    staticClass: "input",
    attrs: {
      size: "small",
      precision: 2,
      min: 0,
      max: 100,
      label: "回函未跟"
    },
    model: {
      value: _vm.filterForm.bank.weigen.value,
      callback: function callback($$v) {
        _vm.$set(_vm.filterForm.bank.weigen, "value", $$v);
      },
      expression: "filterForm.bank.weigen.value"
    }
  }), _c("div", {
    staticClass: "unit"
  }, [_vm._v("%")])], 1), _c("div", {
    staticClass: "filter-component-item"
  }, [_c("div", {
    staticClass: "label"
  }, [_c("el-tag", {
    attrs: {
      size: "small"
    }
  }, [_vm._v(" 回函有效 ")])], 1), _c("el-select", {
    staticClass: "input",
    attrs: {
      size: "small",
      placeholder: "请选择"
    },
    model: {
      value: _vm.filterForm.bank.youxiao.type,
      callback: function callback($$v) {
        _vm.$set(_vm.filterForm.bank.youxiao, "type", $$v);
      },
      expression: "filterForm.bank.youxiao.type"
    }
  }, _vm._l(_vm.filterTypeOptions, function (item) {
    return _c("el-option", {
      key: item.value,
      attrs: {
        label: item.label,
        value: item.value
      }
    });
  }), 1), _c("el-input-number", {
    staticClass: "input",
    attrs: {
      size: "small",
      precision: 2,
      min: 0,
      max: 100,
      label: "回函有效"
    },
    model: {
      value: _vm.filterForm.bank.youxiao.value,
      callback: function callback($$v) {
        _vm.$set(_vm.filterForm.bank.youxiao, "value", $$v);
      },
      expression: "filterForm.bank.youxiao.value"
    }
  }), _c("div", {
    staticClass: "unit"
  }, [_vm._v("%")])], 1), _c("div", {
    staticClass: "filter-component-item"
  }, [_c("div", {
    staticClass: "label"
  }, [_c("el-tag", {
    attrs: {
      size: "small",
      type: "danger"
    }
  }, [_vm._v(" 回函无效 ")])], 1), _c("el-select", {
    staticClass: "input",
    attrs: {
      size: "small",
      placeholder: "请选择"
    },
    model: {
      value: _vm.filterForm.bank.wuxiao.type,
      callback: function callback($$v) {
        _vm.$set(_vm.filterForm.bank.wuxiao, "type", $$v);
      },
      expression: "filterForm.bank.wuxiao.type"
    }
  }, _vm._l(_vm.filterTypeOptions, function (item) {
    return _c("el-option", {
      key: item.value,
      attrs: {
        label: item.label,
        value: item.value
      }
    });
  }), 1), _c("el-input-number", {
    staticClass: "input",
    attrs: {
      size: "small",
      precision: 2,
      min: 0,
      max: 100,
      label: "回函无效"
    },
    model: {
      value: _vm.filterForm.bank.wuxiao.value,
      callback: function callback($$v) {
        _vm.$set(_vm.filterForm.bank.wuxiao, "value", $$v);
      },
      expression: "filterForm.bank.wuxiao.value"
    }
  }), _c("div", {
    staticClass: "unit"
  }, [_vm._v("%")])], 1)])])]), _c("div", {
    staticClass: "item"
  }, [_c("div", {
    staticClass: "name"
  }, [_c("el-tag", {
    attrs: {
      size: "small",
      type: "danger",
      effect: "dark"
    }
  }, [_vm._v(" 往来 ")])], 1), _c("div", {
    staticClass: "sub-wrap"
  }, [_c("div", {
    staticClass: "sub-item"
  }, [_c("div", {
    staticClass: "filter-component-item"
  }, [_c("div", {
    staticClass: "label"
  }, [_c("el-tag", {
    attrs: {
      size: "small",
      type: "success"
    }
  }, [_vm._v(" 回函未跟 ")])], 1), _c("el-select", {
    staticClass: "input",
    attrs: {
      size: "small",
      placeholder: "请选择"
    },
    model: {
      value: _vm.filterForm.w.weigen.type,
      callback: function callback($$v) {
        _vm.$set(_vm.filterForm.w.weigen, "type", $$v);
      },
      expression: "filterForm.w.weigen.type"
    }
  }, _vm._l(_vm.filterTypeOptions, function (item) {
    return _c("el-option", {
      key: item.value,
      attrs: {
        label: item.label,
        value: item.value
      }
    });
  }), 1), _c("el-input-number", {
    staticClass: "input",
    attrs: {
      size: "small",
      precision: 2,
      min: 0,
      max: 100,
      label: "回函未跟"
    },
    model: {
      value: _vm.filterForm.w.weigen.value,
      callback: function callback($$v) {
        _vm.$set(_vm.filterForm.w.weigen, "value", $$v);
      },
      expression: "filterForm.w.weigen.value"
    }
  }), _c("div", {
    staticClass: "unit"
  }, [_vm._v("%")])], 1), _c("div", {
    staticClass: "filter-component-item"
  }, [_c("div", {
    staticClass: "label"
  }, [_c("el-tag", {
    attrs: {
      size: "small"
    }
  }, [_vm._v(" 回函有效 ")])], 1), _c("el-select", {
    staticClass: "input",
    attrs: {
      size: "small",
      placeholder: "请选择"
    },
    model: {
      value: _vm.filterForm.w.youxiao.type,
      callback: function callback($$v) {
        _vm.$set(_vm.filterForm.w.youxiao, "type", $$v);
      },
      expression: "filterForm.w.youxiao.type"
    }
  }, _vm._l(_vm.filterTypeOptions, function (item) {
    return _c("el-option", {
      key: item.value,
      attrs: {
        label: item.label,
        value: item.value
      }
    });
  }), 1), _c("el-input-number", {
    staticClass: "input",
    attrs: {
      size: "small",
      precision: 2,
      min: 0,
      max: 100,
      label: "回函有效"
    },
    model: {
      value: _vm.filterForm.w.youxiao.value,
      callback: function callback($$v) {
        _vm.$set(_vm.filterForm.w.youxiao, "value", $$v);
      },
      expression: "filterForm.w.youxiao.value"
    }
  }), _c("div", {
    staticClass: "unit"
  }, [_vm._v("%")])], 1), _c("div", {
    staticClass: "filter-component-item"
  }, [_c("div", {
    staticClass: "label"
  }, [_c("el-tag", {
    attrs: {
      size: "small",
      type: "danger"
    }
  }, [_vm._v(" 回函无效 ")])], 1), _c("el-select", {
    staticClass: "input",
    attrs: {
      size: "small",
      placeholder: "请选择"
    },
    model: {
      value: _vm.filterForm.w.wuxiao.type,
      callback: function callback($$v) {
        _vm.$set(_vm.filterForm.w.wuxiao, "type", $$v);
      },
      expression: "filterForm.w.wuxiao.type"
    }
  }, _vm._l(_vm.filterTypeOptions, function (item) {
    return _c("el-option", {
      key: item.value,
      attrs: {
        label: item.label,
        value: item.value
      }
    });
  }), 1), _c("el-input-number", {
    staticClass: "input",
    attrs: {
      size: "small",
      precision: 2,
      min: 0,
      max: 100,
      label: "回函无效"
    },
    model: {
      value: _vm.filterForm.w.wuxiao.value,
      callback: function callback($$v) {
        _vm.$set(_vm.filterForm.w.wuxiao, "value", $$v);
      },
      expression: "filterForm.w.wuxiao.value"
    }
  }), _c("div", {
    staticClass: "unit"
  }, [_vm._v("%")])], 1)])])]), _c("div", {
    staticClass: "item"
  }, [_c("div", {
    staticClass: "name"
  }, [_c("el-tag", {
    attrs: {
      type: "info",
      size: "small",
      effect: "dark"
    }
  }, [_vm._v(" 其他 ")])], 1), _c("div", {
    staticClass: "sub-wrap"
  }, [_c("div", {
    staticClass: "sub-item"
  }, [_c("div", {
    staticClass: "filter-component-item"
  }, [_c("div", {
    staticClass: "label"
  }, [_c("el-tag", {
    attrs: {
      size: "small",
      type: "success"
    }
  }, [_vm._v(" 回函未跟 ")])], 1), _c("el-select", {
    staticClass: "input",
    attrs: {
      size: "small",
      placeholder: "请选择"
    },
    model: {
      value: _vm.filterForm.q.weigen.type,
      callback: function callback($$v) {
        _vm.$set(_vm.filterForm.q.weigen, "type", $$v);
      },
      expression: "filterForm.q.weigen.type"
    }
  }, _vm._l(_vm.filterTypeOptions, function (item) {
    return _c("el-option", {
      key: item.value,
      attrs: {
        label: item.label,
        value: item.value
      }
    });
  }), 1), _c("el-input-number", {
    staticClass: "input",
    attrs: {
      size: "small",
      precision: 2,
      min: 0,
      max: 100,
      label: "回函未跟"
    },
    model: {
      value: _vm.filterForm.q.weigen.value,
      callback: function callback($$v) {
        _vm.$set(_vm.filterForm.q.weigen, "value", $$v);
      },
      expression: "filterForm.q.weigen.value"
    }
  }), _c("div", {
    staticClass: "unit"
  }, [_vm._v("%")])], 1), _c("div", {
    staticClass: "filter-component-item"
  }, [_c("div", {
    staticClass: "label"
  }, [_c("el-tag", {
    attrs: {
      size: "small"
    }
  }, [_vm._v(" 回函有效 ")])], 1), _c("el-select", {
    staticClass: "input",
    attrs: {
      size: "small",
      placeholder: "请选择"
    },
    model: {
      value: _vm.filterForm.q.youxiao.type,
      callback: function callback($$v) {
        _vm.$set(_vm.filterForm.q.youxiao, "type", $$v);
      },
      expression: "filterForm.q.youxiao.type"
    }
  }, _vm._l(_vm.filterTypeOptions, function (item) {
    return _c("el-option", {
      key: item.value,
      attrs: {
        label: item.label,
        value: item.value
      }
    });
  }), 1), _c("el-input-number", {
    staticClass: "input",
    attrs: {
      size: "small",
      precision: 2,
      min: 0,
      max: 100,
      label: "回函有效"
    },
    model: {
      value: _vm.filterForm.q.youxiao.value,
      callback: function callback($$v) {
        _vm.$set(_vm.filterForm.q.youxiao, "value", $$v);
      },
      expression: "filterForm.q.youxiao.value"
    }
  }), _c("div", {
    staticClass: "unit"
  }, [_vm._v("%")])], 1), _c("div", {
    staticClass: "filter-component-item"
  }, [_c("div", {
    staticClass: "label"
  }, [_c("el-tag", {
    attrs: {
      size: "small",
      type: "danger"
    }
  }, [_vm._v(" 回函无效 ")])], 1), _c("el-select", {
    staticClass: "input",
    attrs: {
      size: "small",
      placeholder: "请选择"
    },
    model: {
      value: _vm.filterForm.q.wuxiao.type,
      callback: function callback($$v) {
        _vm.$set(_vm.filterForm.q.wuxiao, "type", $$v);
      },
      expression: "filterForm.q.wuxiao.type"
    }
  }, _vm._l(_vm.filterTypeOptions, function (item) {
    return _c("el-option", {
      key: item.value,
      attrs: {
        label: item.label,
        value: item.value
      }
    });
  }), 1), _c("el-input-number", {
    staticClass: "input",
    attrs: {
      size: "small",
      precision: 2,
      min: 0,
      max: 100,
      label: "回函无效"
    },
    model: {
      value: _vm.filterForm.q.wuxiao.value,
      callback: function callback($$v) {
        _vm.$set(_vm.filterForm.q.wuxiao, "value", $$v);
      },
      expression: "filterForm.q.wuxiao.value"
    }
  }), _c("div", {
    staticClass: "unit"
  }, [_vm._v("%")])], 1)])])])])])], 1), _c("div", {
    staticClass: "btn-wrap"
  }, [_c("el-button", {
    attrs: {
      type: "primary",
      size: "small",
      loading: _vm.searching
    },
    on: {
      click: _vm.submit
    }
  }, [_vm._v("筛选")])], 1), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.searching,
      expression: "searching"
    }],
    staticClass: "table",
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.tableData,
      stripe: "",
      "max-height": _vm.maxHeight,
      size: "small",
      fit: true,
      "header-cell-class-name": _vm.headerCellClassName,
      "row-class-name": _vm.rowClassName,
      "cell-class-name": _vm.cellClassName
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "id",
      width: "50",
      label: "作业信息",
      fixed: "left",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.type !== "sum" ? _c("task-info", {
          attrs: {
            id: scope.row._id
          }
        }) : _c("span", [_vm._v("汇总")])];
      }
    }])
  }, [_c("div", {
    staticClass: "table-cell",
    attrs: {
      slot: "header"
    },
    slot: "header"
  }, [_c("div", [_vm._v("作业")]), _c("div", [_vm._v("信息")])])]), _c("el-table-column", {
    attrs: {
      label: "作业函证量统计",
      align: "center",
      prop: "s"
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "s-1",
      align: "center",
      label: "银行函证"
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "s-1-1",
      label: "总量",
      width: "60",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.type !== "sum" ? _c("span", [_vm._v(_vm._s(scope.row.c06YDraft + scope.row.c06YAudit + scope.row.c06YSend + scope.row.c06YBack))]) : _c("span", [_vm._v(_vm._s(scope.row.c06YDraft))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "s-1-2",
      align: "center",
      width: "60",
      label: "发函"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.type !== "sum" ? _c("span", [_vm._v(" " + _vm._s(scope.row.c06YSend + scope.row.c06YBack) + " ")]) : _c("span", [_vm._v(_vm._s(scope.row.c06YSend))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "s-1-3",
      align: "center",
      label: "回函",
      width: "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.type !== "sum" ? _c("div", [_c("div", [_vm._v(" " + _vm._s(scope.row.c06YBack) + " ")]), _c("div", [_vm._v("(" + _vm._s(_vm._f("ratio")(scope.row.yBackRatio)) + ")")])]) : _c("div", [_c("div", [_vm._v(_vm._s(scope.row.c06YBack))])])];
      }
    }])
  }, [_c("div", {
    attrs: {
      slot: "header"
    },
    slot: "header"
  }, [_c("div", [_vm._v("回函")]), _c("div", [_vm._v("(比例)")])])])], 1), _c("el-table-column", {
    attrs: {
      prop: "s-2",
      label: "往来函证",
      align: "center"
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "s-2-1",
      label: "总量",
      width: "60",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.type !== "sum" ? _c("span", [_vm._v(" " + _vm._s(scope.row.c06WDraft + scope.row.c06WAudit + scope.row.c06WSend + scope.row.c06WBack) + " ")]) : _c("span", [_vm._v(_vm._s(scope.row.c06WDraft))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "s-2-2",
      width: "60",
      label: "发函",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.type !== "sum" ? _c("span", [_vm._v(" " + _vm._s(scope.row.c06WSend + scope.row.c06WBack) + " ")]) : _c("span", [_vm._v(_vm._s(scope.row.c06WSend))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "s-2-3",
      label: "回函",
      align: "center",
      width: "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.type !== "sum" ? _c("div", [_c("div", [_vm._v(" " + _vm._s(scope.row.c06WBack) + " ")]), _c("div", [_vm._v("(" + _vm._s(_vm._f("ratio")(scope.row.wBackRatio)) + ")")])]) : _c("span", [_vm._v(_vm._s(scope.row.c06WBack))])];
      }
    }])
  }, [_c("div", {
    attrs: {
      slot: "header"
    },
    slot: "header"
  }, [_c("div", [_vm._v("回函")]), _c("div", [_vm._v("(比例)")])])])], 1), _c("el-table-column", {
    attrs: {
      prop: "s-3",
      label: "其他函证",
      align: "center"
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "s-3-1",
      width: "60",
      label: "总量",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.type !== "sum" ? _c("span", [_vm._v(" " + _vm._s(scope.row.c06QDraft + scope.row.c06QAudit + scope.row.c06QSend + scope.row.c06QBack) + " ")]) : _c("span", [_vm._v(_vm._s(scope.row.c06QDraft))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "s-3-2",
      label: "发函",
      align: "center",
      width: "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.type !== "sum" ? _c("span", [_vm._v(" " + _vm._s(scope.row.c06QSend + scope.row.c06QBack) + " ")]) : _c("span", [_vm._v(_vm._s(scope.row.c06QSend))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "s-3-3",
      label: "回函",
      width: "60",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.type !== "sum" ? _c("div", [_c("div", [_vm._v(" " + _vm._s(scope.row.c06QBack) + " ")]), _c("div", [_vm._v("(" + _vm._s(_vm._f("ratio")(scope.row.qBackRatio)) + ")")])]) : _c("span", [_vm._v(_vm._s(scope.row.c06QBack))])];
      }
    }])
  }, [_c("div", {
    attrs: {
      slot: "header"
    },
    slot: "header"
  }, [_c("div", [_vm._v("回函")]), _c("div", [_vm._v("(比例)")])])])], 1)], 1), _c("el-table-column", {
    attrs: {
      align: "center",
      label: "回函异常函证统计",
      prop: "a"
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "a-1",
      label: "银行函证",
      align: "center"
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "a-1-1",
      label: "不符数量",
      width: "60",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.type !== "sum" ? _c("div", [_c("div", [_vm._v(" " + _vm._s(scope.row.c06YBConclusion) + " ")]), _c("div", [_vm._v("(" + _vm._s(_vm._f("ratio")(scope.row.yBConclusionRatio)) + ")")])]) : _c("span", [_vm._v(_vm._s(scope.row.c06YBConclusion))])];
      }
    }])
  }, [_c("div", {
    staticClass: "table-cell",
    attrs: {
      slot: "header"
    },
    slot: "header"
  }, [_c("div", [_vm._v("结论")]), _c("div", [_vm._v("不符")])])]), _c("el-table-column", {
    attrs: {
      prop: "a-1-2",
      align: "center",
      label: "函证异常数量",
      width: "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.type !== "sum" ? _c("div", [_c("div", [_vm._v(" " + _vm._s(scope.row.c06YBStatus) + " ")]), _c("div", [_vm._v("(" + _vm._s(_vm._f("ratio")(scope.row.yBStatusRatio)) + ")")])]) : _c("span", [_vm._v(_vm._s(scope.row.c06YBStatus))])];
      }
    }])
  }, [_c("div", {
    staticClass: "table-cell",
    attrs: {
      slot: "header"
    },
    slot: "header"
  }, [_c("div", [_vm._v("函证")]), _c("div", [_vm._v("异常")])])]), _c("el-table-column", {
    attrs: {
      prop: "a-1-3",
      align: "center",
      label: "地址异常数量",
      width: "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.type !== "sum" ? _c("div", [_c("div", [_vm._v(" " + _vm._s(scope.row.c06YBAddress) + " ")]), _c("div", [_vm._v("(" + _vm._s(_vm._f("ratio")(scope.row.yBAddressRatio)) + ")")])]) : _c("span", [_vm._v(_vm._s(scope.row.c06YBAddress))])];
      }
    }])
  }, [_c("div", {
    staticClass: "table-cell",
    attrs: {
      slot: "header"
    },
    slot: "header"
  }, [_c("div", [_vm._v("地址")]), _c("div", [_vm._v("异常")])])])], 1), _c("el-table-column", {
    attrs: {
      prop: "a-2",
      label: "往来函证",
      align: "center"
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "a-2-1",
      label: "不符数量",
      align: "center",
      width: "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.type !== "sum" ? _c("div", [_c("div", [_vm._v(" " + _vm._s(scope.row.c06WBConclusion) + " ")]), _c("div", [_vm._v("(" + _vm._s(_vm._f("ratio")(scope.row.wBConclusionRatio)) + ")")])]) : _c("span", [_vm._v(_vm._s(scope.row.c06WBConclusion))])];
      }
    }])
  }, [_c("div", {
    staticClass: "table-cell",
    attrs: {
      slot: "header"
    },
    slot: "header"
  }, [_c("div", [_vm._v("结论")]), _c("div", [_vm._v("不符")])])]), _c("el-table-column", {
    attrs: {
      prop: "a-2-2",
      align: "center",
      label: "函证异常数量",
      width: "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.type !== "sum" ? _c("div", [_c("div", [_vm._v(" " + _vm._s(scope.row.c06WBStatus) + " ")]), _c("div", [_vm._v("(" + _vm._s(_vm._f("ratio")(scope.row.wBStatusRatio)) + ")")])]) : _c("span", [_vm._v(_vm._s(scope.row.c06WBStatus))])];
      }
    }])
  }, [_c("div", {
    staticClass: "table-cell",
    attrs: {
      slot: "header"
    },
    slot: "header"
  }, [_c("div", [_vm._v("函证")]), _c("div", [_vm._v("异常")])])]), _c("el-table-column", {
    attrs: {
      prop: "a-2-3",
      align: "center",
      label: "地址异常数量",
      width: "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.type !== "sum" ? _c("div", [_c("div", [_vm._v(" " + _vm._s(scope.row.c06WBAddress) + " ")]), _c("div", [_vm._v("(" + _vm._s(_vm._f("ratio")(scope.row.wBAddressRatio)) + ")")])]) : _c("span", [_vm._v(_vm._s(scope.row.c06WBAddress))])];
      }
    }])
  }, [_c("div", {
    staticClass: "table-cell",
    attrs: {
      slot: "header"
    },
    slot: "header"
  }, [_c("div", [_vm._v("地址")]), _c("div", [_vm._v("异常")])])])], 1), _c("el-table-column", {
    attrs: {
      prop: "a-3",
      align: "center",
      label: "其他函证"
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "a-3-1",
      label: "不符数量",
      width: "60",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.type !== "sum" ? _c("div", [_c("div", [_vm._v(" " + _vm._s(scope.row.c06QBConclusion) + " ")]), _c("div", [_vm._v("(" + _vm._s(_vm._f("ratio")(scope.row.qBConclusionRatio)) + ")")])]) : _c("span", [_vm._v(_vm._s(scope.row.c06QBConclusion))])];
      }
    }])
  }, [_c("div", {
    staticClass: "table-cell",
    attrs: {
      slot: "header"
    },
    slot: "header"
  }, [_c("div", [_vm._v("结论")]), _c("div", [_vm._v("不符")])])]), _c("el-table-column", {
    attrs: {
      prop: "a-3-2",
      label: "函证异常数量",
      align: "center",
      width: "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.type !== "sum" ? _c("div", [_c("div", [_vm._v(" " + _vm._s(scope.row.c06QBStatus) + " ")]), _c("div", [_vm._v("(" + _vm._s(_vm._f("ratio")(scope.row.qBStatusRatio)) + ")")])]) : _c("span", [_vm._v(_vm._s(scope.row.c06QBStatus))])];
      }
    }])
  }, [_c("div", {
    staticClass: "table-cell",
    attrs: {
      slot: "header"
    },
    slot: "header"
  }, [_c("div", [_vm._v("函证")]), _c("div", [_vm._v("异常")])])]), _c("el-table-column", {
    attrs: {
      prop: "a-3-3",
      align: "center",
      label: "地址异常数量",
      width: "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.type !== "sum" ? _c("div", [_c("div", [_vm._v(" " + _vm._s(scope.row.c06QBAddress) + " ")]), _c("div", [_vm._v("(" + _vm._s(_vm._f("ratio")(scope.row.qBAddressRatio)) + ")")])]) : _c("span", [_vm._v(_vm._s(scope.row.c06QBAddress))])];
      }
    }])
  }, [_c("div", {
    staticClass: "table-cell",
    attrs: {
      slot: "header"
    },
    slot: "header"
  }, [_c("div", [_vm._v("地址")]), _c("div", [_vm._v("异常")])])])], 1)], 1), _c("el-table-column", {
    attrs: {
      align: "center",
      label: "项目组跟踪回函统计",
      prop: "g"
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "g-1",
      label: "银行函证",
      align: "center"
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "g-1-1",
      label: "已回函但未跟踪",
      width: "60",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.type !== "sum" ? _c("div", [_c("div", [_vm._v(" " + _vm._s(scope.row.c06YBack - scope.row.c06YBEffective - scope.row.c06YBInvalid) + " ")]), _c("div", [_vm._v("(" + _vm._s(_vm._f("ratio")(scope.row.yOfftrackRatio)) + ")")])]) : _c("span", [_vm._v(_vm._s(scope.row.c06YBack2))])];
      }
    }])
  }, [_c("div", {
    staticClass: "table-cell",
    attrs: {
      slot: "header"
    },
    slot: "header"
  }, [_c("div", [_vm._v("回函")]), _c("div", [_vm._v("未跟")])])]), _c("el-table-column", {
    attrs: {
      prop: "g-1-2",
      align: "center",
      width: "60",
      label: "已回函且有效"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.type !== "sum" ? _c("div", [_c("div", [_vm._v(" " + _vm._s(scope.row.c06YBEffective) + " ")]), _c("div", [_vm._v("(" + _vm._s(_vm._f("ratio")(scope.row.yBEffectiveRatio)) + ")")])]) : _c("span", [_vm._v(_vm._s(scope.row.c06YBEffective))])];
      }
    }])
  }, [_c("div", {
    staticClass: "table-cell",
    attrs: {
      slot: "header"
    },
    slot: "header"
  }, [_c("div", [_vm._v("回函")]), _c("div", [_vm._v("有效")])])]), _c("el-table-column", {
    attrs: {
      prop: "g-1-3",
      align: "center",
      width: "60",
      label: "已回函且无效"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.type !== "sum" ? _c("div", [_c("div", [_vm._v(" " + _vm._s(scope.row.c06YBInvalid) + " ")]), _c("div", [_vm._v("(" + _vm._s(_vm._f("ratio")(scope.row.yBInvalidRatio)) + ")")])]) : _c("span", [_vm._v(_vm._s(scope.row.c06YBInvalid))])];
      }
    }])
  }, [_c("div", {
    staticClass: "table-cell",
    attrs: {
      slot: "header"
    },
    slot: "header"
  }, [_c("div", [_vm._v("回函")]), _c("div", [_vm._v("无效")])])])], 1), _c("el-table-column", {
    attrs: {
      prop: "g-2",
      label: "往来函证",
      align: "center"
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "g-2-1",
      label: "已回函但未跟踪",
      width: "60",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.type !== "sum" ? _c("div", [_c("div", [_vm._v(" " + _vm._s(scope.row.c06WBack - scope.row.c06WBEffective - scope.row.c06WBInvalid) + " ")]), _c("div", [_vm._v("(" + _vm._s(_vm._f("ratio")(scope.row.wOfftrackRatio)) + ")")])]) : _c("span", [_vm._v(_vm._s(scope.row.c06WBack2))])];
      }
    }])
  }, [_c("div", {
    staticClass: "table-cell",
    attrs: {
      slot: "header"
    },
    slot: "header"
  }, [_c("div", [_vm._v("回函")]), _c("div", [_vm._v("未跟")])])]), _c("el-table-column", {
    attrs: {
      prop: "g-2-2",
      label: "已回函且有效",
      align: "center",
      width: "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.type !== "sum" ? _c("div", [_c("div", [_vm._v(" " + _vm._s(scope.row.c06WBEffective) + " ")]), _c("div", [_vm._v("(" + _vm._s(_vm._f("ratio")(scope.row.wBEffectiveRatio)) + ")")])]) : _c("span", [_vm._v(_vm._s(scope.row.c06WBEffective))])];
      }
    }])
  }, [_c("div", {
    staticClass: "table-cell",
    attrs: {
      slot: "header"
    },
    slot: "header"
  }, [_c("div", [_vm._v("回函")]), _c("div", [_vm._v("有效")])])]), _c("el-table-column", {
    attrs: {
      prop: "g-2-3",
      align: "center",
      width: "60",
      label: "已回函且无效"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.type !== "sum" ? _c("div", [_c("div", [_vm._v(" " + _vm._s(scope.row.c06WBInvalid) + " ")]), _c("div", [_vm._v("(" + _vm._s(_vm._f("ratio")(scope.row.wBInvalidRatio)) + ")")])]) : _c("span", [_vm._v(_vm._s(scope.row.c06WBInvalid))])];
      }
    }])
  }, [_c("div", {
    staticClass: "table-cell",
    attrs: {
      slot: "header"
    },
    slot: "header"
  }, [_c("div", [_vm._v("回函")]), _c("div", [_vm._v("无效")])])])], 1), _c("el-table-column", {
    attrs: {
      prop: "g-3",
      label: "其他函证",
      align: "center"
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "g-3-1",
      width: "60",
      label: "已回函但未跟踪",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.type !== "sum" ? _c("div", [_c("div", [_vm._v(" " + _vm._s(scope.row.c06QBack - scope.row.c06QBEffective - scope.row.c06QBInvalid) + " ")]), _c("div", [_vm._v("(" + _vm._s(_vm._f("ratio")(scope.row.qOfftrackRatio)) + ")")])]) : _c("span", [_vm._v(_vm._s(scope.row.c06QBack2))])];
      }
    }])
  }, [_c("div", {
    staticClass: "table-cell",
    attrs: {
      slot: "header"
    },
    slot: "header"
  }, [_c("div", [_vm._v("回函")]), _c("div", [_vm._v("未跟")])])]), _c("el-table-column", {
    attrs: {
      prop: "g-3-2",
      width: "60",
      align: "center",
      label: "已回函且有效"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.type !== "sum" ? _c("div", [_c("div", [_vm._v(" " + _vm._s(scope.row.c06QBEffective) + " ")]), _c("div", [_vm._v("(" + _vm._s(_vm._f("ratio")(scope.row.qBEffectiveRatio)) + ")")])]) : _c("span", [_vm._v(_vm._s(scope.row.c06QBEffective))])];
      }
    }])
  }, [_c("div", {
    staticClass: "table-cell",
    attrs: {
      slot: "header"
    },
    slot: "header"
  }, [_c("div", [_vm._v("回函")]), _c("div", [_vm._v("有效")])])]), _c("el-table-column", {
    attrs: {
      prop: "g-3-3",
      width: "60",
      label: "已回函且无效",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.type !== "sum" ? _c("div", [_c("div", [_vm._v(" " + _vm._s(scope.row.c06QBInvalid) + " ")]), _c("div", [_vm._v("(" + _vm._s(_vm._f("ratio")(scope.row.qBInvalidRatio)) + ")")])]) : _c("span", [_vm._v(_vm._s(scope.row.c06QBInvalid))])];
      }
    }])
  }, [_c("div", {
    staticClass: "table-cell",
    attrs: {
      slot: "header"
    },
    slot: "header"
  }, [_c("div", [_vm._v("回函")]), _c("div", [_vm._v("无效")])])])], 1)], 1)], 1)], 1), _vm.isAdmin || _vm.isCpscAdmin ? _c("el-tab-pane", {
    attrs: {
      lazy: "",
      label: "收发函绩效",
      name: "performance"
    }
  }, [_c("performance")], 1) : _vm._e(), _vm.isAdmin || _vm.isCpscAdmin ? _c("el-tab-pane", {
    attrs: {
      lazy: "",
      label: "未领取",
      name: "unclaimed"
    }
  }, [_c("unclaimed")], 1) : _vm._e()], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };